import { GET_STATIC_DATA, SET_STATIC_DATA } from "./staticDataTypes";

const initialState = {
  yearList: [],
  countryList: [],
  businessIndustryList: [],
  businessTypeList: [],
  messageTypeList: [],
  sendMessageTypeList: [],
  defaultCountry: {},
  optinCollectionOptionList: [],
  organizationTypeList: [],
  optinPermissonMethodList: [],
  crmIntegrationList: [],
  pledgePaymentIntegrationList: [],
  smsCategoryColorList: [],
  smsMessageTypeList: [],
  smsActivityAlertList: [],
  interactiveQuestionTypeList: [],
  smsVariablesList: [],
  smsFundraisingOptionList: [],
  paymentServiceTypeList: [],
  reminderTypes: [],
  cventDataCarryoverTypes: [],
  eventTypes: [],
  regionList: [],
};

const staticDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STATIC_DATA:
      return {
        ...state,
      };
    case SET_STATIC_DATA:
      return {
        ...state,
        yearList: action.payload.yearList,
        countryList: action.payload.countryList,
        businessIndustryList: action.payload.businessIndustryList,
        businessTypeList: action.payload.businessTypeList,
        messageTypeList: action.payload.messageTypeList,
        sendMessageTypeList: action.payload.sendMessageTypeList,
        optinCollectionOptionList: action.payload.optinCollectionOptionList,
        organizationTypeList: action.payload.organizationTypeList,
        optinPermissonMethodList: action.payload.optinPermissonMethodList,
        defaultCountry: action.payload.defaultCountry,
        crmIntegrationList: action.payload.crmIntegrationList,
        pledgePaymentIntegrationList:
          action.payload.pledgePaymentIntegrationList,
        smsMessageTypeList: action.payload.smsMessageTypeList,
        smsCategoryColorList: action.payload.smsCategoryColorList,
        smsActivityAlertList: action.payload.smsActivityAlertList,
        interactiveQuestionTypeList: action.payload.interactiveQuestionTypeList,
        smsVariablesList: action.payload.smsVariablesList,
        smsFundraisingOptionList: action.payload.smsFundraisingOptionList,
        paymentServiceTypeList: action.payload.paymentServiceTypeList,
        reminderTypes: action.payload.reminderTypes,
        cventDataCarryoverTypes: action.payload.cventDataCarryoverTypes,
        eventTypes: action.payload.eventTypes,
        regionList: action.payload.regionList,
      };

    default:
      return state;
  }
};

export default staticDataReducer;
